const COMMENT = {
  ACTIONS: {
    LIKE: 'like',
    DISLIKE: 'dislike',
    REMOVE: 'remove',
  },
  LIMIT: 10,
  REPLIES_LIMIT: 5,
  REVIEWS_SORT: 'relevance',
  SORT_VALUES: {
    OLDEST: 'oldest',
    LATEST: 'latest',
    RELEVANCE: 'relevance',
  },
  STATUSES: {
    WAITING: 'WAITING',
    PROCESSING: 'PROCESSING',
    APPROVED: 'APPROVED',
    REMOVED_BY_ADMIN: 'REMOVED_BY_ADMIN',
    REMOVED_BY_USER: 'REMOVED_BY_USER',
    REMOVED_FOR_ALL: 'REMOVED_FOR_ALL',
    PARTIALLY_REMOVED: 'REMOVED_PARCIAL',
    USELESS: 'USELESS',
  },
};

export default COMMENT;
